<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <div class="animals-view-pg plants-view-pg">
      <h1 class="title-pg">{{ flora.name }} {{ flora.latinName ? '('+flora.latinName+')' : '' }}</h1>
      <div class="animals-view-head bgw-pdg-20">
        <v-row>
          <v-col class="col-image">
            <template v-if="flora.galleries && flora.galleries.length > 0">
              <div class="img-lg">
                <v-img :src="backUrl + photo"></v-img>
              </div>
              <div class="photo-details" v-if="photo">
                <div class="photograph">© <span v-text="authorPhoto"></span></div>
                <div class="source">{{ $t('Источник') }}: <span v-text="descriptionPhoto"></span></div>
              </div>
              <div class="img-mini">
                <div class="img-item" v-for="(gallery, i) in flora.galleries" :key="gallery.id">
                  <v-img @click="changeMainPhoto(i)" width="100" height="70" :src="backUrl + gallery.fullFilesDirectory"></v-img>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="no-img-lg"></div>
            </template>
          </v-col>
          <v-col class="col-description">
            <div class="table-overflow">
              <table class="table-full">
                <tbody>
                  <tr>
                    <td class="td-name">{{ $t('Код по классификации') }}</td>
                    <td><strong>{{ flora.codeChain }}</strong></td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Вид') }}</td>
                    <td>{{ flora.name }} <br/> {{ flora.latinName }}</td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Альтернативное название') }}</td>
                    <td>{{ flora.alternativeName }}</td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Род') }}</td>
                    <td>{{ flora.genus }}</td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Семейство') }}</td>
                    <td>{{ flora.family }}</td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Класс') }}</td>
                    <td>{{ flora.class }}</td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Отдел') }}</td>
                    <td>{{ flora.branch }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-overflow">
              <table class="table-full">
                <tbody>
                  <tr>
                    <td class="td-name">{{ $t('Межд. охранный статус') }}</td>
                    <td>
                      <span v-if="flora.interStatus">{{ flora.interStatus }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Национальный статус') }}</td>
                    <td>
                      <span v-if="flora.nationalStatus">{{ flora.nationalStatus }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-name">{{ $t('Красная книга КР') }}</td>
                    <td>
                      <span
                        v-if="flora.redBook && flora.redBook === true"
                      >{{ $t("да") }}</span>
                      <span v-else>{{ $t("нет") }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="animals-view-body">
        <div class="description-item bgw-pdg-20">
          <h5>{{ $t('Описание вида') }}</h5>
          <div v-html="flora.description"></div>
          <div class="source-info">{{ $t('Источник') }}: {{ flora.dataSource }}</div>
        </div>
        <div class="description-item bgw-pdg-20">
          <div class="table-overflow">
            <table>
              <tbody>
                <tr>
                  <td class="td-name">{{ $t('Происхождение') }}</td>
                  <td>
                    {{ flora.origin }}
                  </td>
                </tr>
                <tr>
                  <td class="td-name">{{ $t('Артефакт') }}</td>
                  <td>
                    <span
                      v-if="flora.artifact && flora.artifact === true"
                      >{{ $t("да") }}</span>
                    <span v-else>{{ $t("нет") }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import flora from '@/model/flora'
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    flora: {},
    breadcrumbs: [],
    backUrl: process.env.VUE_APP_BACK_URL,
    photo: '',
    authorPhoto: '',
    descriptionPhoto: ''
  }),
  created () {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),

    fetchData () {
      this.setLoading(true)

      flora.getFloraView(this.$route.params.id)
        .then((response) => {
          if (response.status === 400) {
            this.$router.push({
              name: 'flora'
            })
          }
          this.flora = response.data.flora
          this.changeMainPhoto(0)
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('База данных растительного мира КР'),
              disabled: false,
              href: '/flora'
            },
            {
              text: this.flora.name,
              disabled: true
            }
          ]
          this.scrollToTop()
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.$router.push({
            name: 'Animals'
          })
        })
    },
    // Изменение главного фото
    changeMainPhoto (i) {
      const gallery = this.flora.galleries[i]
      if (gallery) {
        this.photo = gallery.fullFilesDirectory
        this.authorPhoto = gallery.transAuthor
        this.descriptionPhoto = gallery.transDescription
      }
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
